const {WixError, wixBusinessError, wixSystemError, HttpStatus, ErrorCode} = require('@wix/wix-errors');

// Wix errors start at -100 da error -201
const NewErrorCode = Object.assign({}, ErrorCode, {
  PAPI_ERROR: -201,
  USER_BANNED: -202,
  USER_DEACTIVATED: -203,
  USER_SUSPENDED: -204,
  USER_BETA_FEATURE: -205,
  BROWSER_NOREFERRER: -206,
  ABUSE_PAGE_FLOODER: -207,
  ABUSE_THREAD_FLOODER: -208,
  GROUP_INACTIVE: -209,
  CHAT_COMING_SOON: -210,
});

module.exports = {
  DaError: WixError, 
  daBusinessError: wixBusinessError, 
  daSystemError: wixSystemError, 
  HttpStatus, 
  ErrorCode: NewErrorCode,
};
